module.exports = __webpack_public_path__ + "img/ic-file.9a1b01de.svg";